import dayjs, {Dayjs} from 'dayjs';
import {json} from '../core/data-source/json.mapper';
import {DayShift} from './driver-availability.record';

export const locationAvailabilityDaysIndexMap = {
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
    sunday: 7
};

const availabilityDaysIndexMap = {
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6,
    sunday: 7
};

export class LocationAvailabilityRecord {
    @json({
        jsonName: 'start_time',
        force: true,
        mapper: {
            from: (time: string): Dayjs => {
                if (!time) {
                    return null;
                }
                let timeToDate: Dayjs = dayjs.utc(time, 'HH:mm');
                const date: Dayjs = dayjs
                    .utc(0)
                    .set('hours', timeToDate.get('hours'))
                    .set('minutes', timeToDate.get('minutes'));
                return date;
            },
            to: (date: Dayjs): string => (date ? date.format('HH:mm') : '')
        }
    })
    startTime: Dayjs;

    @json({
        jsonName: 'end_time',
        force: true,
        mapper: {
            from: (time: string): Dayjs => {
                if (!time) {
                    return null;
                }
                let timeToDate: Dayjs = dayjs.utc(time, 'HH:mm');
                const date: Dayjs = dayjs
                    .utc(0)
                    .set('hours', timeToDate.get('hours'))
                    .set('minutes', timeToDate.get('minutes'));
                return date;
            },
            to: (date: Dayjs): string => (date ? date.format('HH:mm') : '')
        }
    })
    endTime: Dayjs;

    @json({
        value: true
    })
    available: boolean;

    @json({
        jsonName: 'day_of_week'
    })
    dayOfWeek: string;

    @json({
        skip: true,
        jsonName: 'day_of_week',
        mapper: {
            from: (value: string) => {
                return locationAvailabilityDaysIndexMap[value];
            }
        }
    })
    numberDayOfWeek: number;

    @json({
        jsonName: 'fixed_work_day_start'
    })
    fixedWorkDayStart: boolean;

    @json() startDayShift: number;

    @json() endDayShift: number;

    startDay: DayShift = DayShift.sameDay;

    endDay: DayShift = DayShift.sameDay;

    @json({
        mapper: {
            from: (value: any, record: any) => !record.startTime && !record.endTime
        }
    })
    isEmpty: boolean;
}
